module.exports = __webpack_public_path__ + "sansg/img/girl-924903.eb2d83c0.png";